/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';
import { Schema } from './schema';


export interface BusinessObjectFormatUpdateRequest { 
    /**
     * Description of the Business Object Format
     */
    description?: string;
    /**
     * The schema for document-style business object data registered with Herd. The schema allows the publisher to perform                   self-service validation of incoming data when registering business object data. It also allows the consumers to perform self-service                   downstream actions like hydrating objects when consuming business object data. The documentSchema is optional. Currently any documentSchema is                   accepted. Its content is not validated                
     */
    documentSchema?: string;
    /**
     * An optional URL of the documentSchema to an externally hosted XSD or JSON. Herd will not access this URL,                   it will simply store and retrieve the URL and teams can then access the URL                
     */
    documentSchemaUrl?: string;
    /**
     * Custom user-defined metadata associated with this Business Object Format. \"name\" is the attribute name (i.e. the key) and                   \"value\" is the attribute value                
     */
    attributes?: Array<Attribute>;
    schema?: Schema;
}
